import axios from "@/libs/api.request";
export function getLeftTreeList(params) {
    return axios.request({
        url: "Album/getLeftTreeList",
        method: "get",
        params:params,
    })
}
export function getDataList(params) {
    return axios.request({
        url: "Album/getDataList",
        method: "get",
        params:params,
    })
}
export function submitAlbum(params) {
    return axios.request({
        url: "Album/CreateUpdate",
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}
// 删除 
export function delAlbum(id) {
    return axios.request({
        url: "Album/Delete",
        method: "post",
        params:{id:id}
    })
}